import React from "react";
import axios from "axios";

export const signupApi = async (first_name, last_name, phone_number, email, password) => {
  try {
    let url = "https://visapro-api.tcore.online/api/v1/auth/register";

    const response = await axios.post(url, {
      first_name,
      last_name,
      phone_number,
      email,
      password,
      role: "CUSTOMER",
    });
    const signup = {
      data: response.data,
    };
    return signup;
  } catch (error) {
    const signup = {
      error: error,
    };
    return signup;
  }
};
